import styled from 'styled-components'

export const CooperationList = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  box-shadow: 1px 2px 1px 0 rgba(0, 0, 0, 0.13);

  .cooperation-header {
    padding: 20px 30px 10px;
    display: flex;
    align-items: center;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    background-color: ${ (props) => props.theme.colors['hintergrund-allgemein'] };
    width: 100%;
    color: ${ (props) => props.theme.colors['standard-schwarz'] };

    &:hover {
      text-decoration: none;
      color: ${ (props) => props.theme.colors['standard-schwarz'] };
    }

    .name {
      font-size: 22px;
      line-height: 27px;

      @media ${ (props) => props.theme.breakpoints.devices.min.md }, print {
        font-size: 24px;
        line-height: 32px;
      }
    }
  }

  // overwrite accordion styles
  .cooperation-list-accordion {
    > div:first-child {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding-right: 30px;
    }
  }
`
